"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var condition_display_1 = require("@reverbdotcom/commons/dist/components/condition_display");
var price_display_1 = require("@reverbdotcom/commons/dist/components/price_display");
var image_carousel_1 = require("@reverbdotcom/commons/dist/components/image_carousel");
var ribbon_view_1 = require("@reverbdotcom/commons/dist/components/ribbon_view");
var tile_curation_view_1 = require("./curation/tile_curation_view");
var user_store_1 = require("../../reverb-js-common/user_store");
var bind_1 = require("../../bind");
var watch_badge_1 = require("./watch_badge");
var location_util_1 = require("../shared/location_util");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var ListingCard = /** @class */ (function (_super) {
    tslib_1.__extends(ListingCard, _super);
    function ListingCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingCard.prototype.trackClick = function () {
        tracker_1.trackInteraction({
            componentName: this.props.trackName,
            url: this.props.listing.link('web'),
            type: tracker_1.LISTING_TYPE,
            entityId: this.props.listing.id,
            position: this.props.position,
            context: this.props.trackContext,
        });
    };
    ListingCard.prototype.listingClicked = function () {
        this.trackClick();
        this.props.listingClicked(this.props.listing);
    };
    Object.defineProperty(ListingCard.prototype, "user", {
        get: function () {
            return this.props.user || { experiments: [] };
        },
        enumerable: true,
        configurable: true
    });
    ListingCard.prototype.hasDiscount = function () {
        return !!this.props.listing.original_price;
    };
    ListingCard.prototype.ribbonText = function () {
        return this.props.listing.ribbon ?
            this.props.listing.ribbon.display :
            null;
    };
    ListingCard.prototype.listingUrl = function () {
        var url = new URL(this.props.listing.link('web'));
        if (location_util_1.default.filteringShowOnlySold()) {
            url.search += 'show_sold=true';
        }
        return url.pathname + url.search;
    };
    ListingCard.prototype.renderCuration = function () {
        if (!user_store_1.default.getState().isAdmin) {
            return null;
        }
        return (React.createElement(tile_curation_view_1.default, { listingId: this.props.listing.id, admin: this.props.listing.admin }));
    };
    ListingCard.prototype.renderConditionDisplay = function () {
        if (this.props.listing.isDigitalListing)
            return;
        return (React.createElement("div", { className: "grid-card__condition" },
            React.createElement(condition_display_1.default, { slug: this.props.listing.condition.slug, displayName: this.props.listing.condition.display_name })));
    };
    ListingCard.prototype.renderWatchBadge = function () {
        if (typeof this.props.listing.watching === 'undefined') {
            return null;
        }
        if (user_store_1.default.getState().loggedOut) {
            return null;
        }
        return (React.createElement("div", { className: "grid-card__watch" },
            React.createElement(watch_badge_1.default, { listing: this.props.listing })));
    };
    ListingCard.prototype.renderFreeExpeditedShipping = function () {
        if (!this.props.listing.free_expedited_shipping) {
            return null;
        }
        return (React.createElement("div", { className: "grid-card__free-2-day" }, I18n.t('discovery.freeExpeditedShipping')));
    };
    ListingCard.prototype.renderOriginalPrice = function () {
        if (!this.hasDiscount()) {
            return null;
        }
        return (React.createElement("div", { className: "grid-card__original-price" }, this.props.listing.original_price.display));
    };
    ListingCard.prototype.renderPrice = function () {
        return (React.createElement(price_display_1.default, { amountCents: this.props.listing.buyer_price.amount_cents, currency: this.props.listing.buyer_price.currency, display: this.props.listing.buyer_price.display, auction: this.props.listing.auction }));
    };
    ListingCard.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "grid-card grid-card--placeholder" },
            React.createElement("div", { className: "grid-card__inner" },
                React.createElement("div", { className: "grid-card__main" },
                    React.createElement("div", { className: "grid-card__image" }),
                    React.createElement("div", { className: "grid-card__main__text" },
                        React.createElement("div", { className: "grid-card__title" }))),
                React.createElement("div", { className: "grid-card__footer" },
                    React.createElement("div", { className: "grid-card__footer__pricing" },
                        React.createElement("div", { className: "grid-card__price" }),
                        React.createElement("div", { className: "grid-card__condition" }))))));
    };
    ListingCard.prototype.render = function () {
        if (!this.props.listing)
            return this.renderPlaceholder();
        var classes = classNames('grid-card', { 'grid-card--software': this.props.listing.isDigitalListing }, { 'grid-card--discounted': this.hasDiscount() });
        var images = this.props.listing.images.map(function (i) { return (i._links.small.href); });
        return (React.createElement("div", { className: classes },
            React.createElement("a", { className: "grid-card__inner", onClick: this.listingClicked, href: this.listingUrl() },
                React.createElement("div", { className: "grid-card__main" },
                    React.createElement("div", { className: "grid-card__image" },
                        React.createElement(image_carousel_1.default, { images: images, imgAlt: this.props.listing.title }),
                        React.createElement(ribbon_view_1.default, { auction: this.props.listing.auction, listingStateDescription: this.props.listing.state.description, listingStateSlug: this.props.listing.state.slug, discountDisplay: this.ribbonText() })),
                    React.createElement("div", { className: "grid-card__main__text" },
                        React.createElement("h4", { className: "grid-card__title" }, this.props.listing.title))),
                React.createElement("div", { className: "grid-card__footer" },
                    this.renderFreeExpeditedShipping(),
                    this.renderOriginalPrice(),
                    React.createElement("div", { className: "grid-card__footer__pricing", onClick: this.listingClicked },
                        React.createElement("div", { className: "grid-card__price" }, this.renderPrice()),
                        this.renderConditionDisplay()),
                    this.renderCuration())),
            this.renderWatchBadge()));
    };
    ListingCard.defaultProps = {
        condensed: false,
        listingClicked: function () { },
        trackName: 'ListingCard',
    };
    tslib_1.__decorate([
        bind_1.default
    ], ListingCard.prototype, "listingClicked", null);
    return ListingCard;
}(React.Component));
exports.ListingCard = ListingCard;
exports.default = user_context_provider_1.withUserContext(ListingCard);
//# sourceMappingURL=listing_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/listing_card.js
// module id = 183K
// module chunks = 20 21